// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__Irb_q","overflowing":"ReadFullNote_overflowing__nUaaV"};